// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"style-module--iconContainer--Q8xa2","shareButton":"style-module--shareButton--4irP6"};